import AxiosService from './AxiosService'

class LoginDelayRestService {
  static get(): Promise<any> {
    return AxiosService.get('/loginDelay')
  }

  static update(loginDelay: any): Promise<any> {
    return AxiosService.put('/loginDelay', loginDelay)
  }

  static reset(): Promise<any> {
    return AxiosService.put('/loginDelay/reset')
  }
}

export default LoginDelayRestService
